const shipmentStatusMap = {
  CREATED: 'Created',
  VALIDATION_FAILED: 'Validation failed',
  LABEL_GENERATED: 'Label Generated',
  MANIFESTED: 'Manifested',
  MANIFESTATION_FAILED: 'Manifest Failed',
  USER_INPUT_REQUIRED: 'User Input Required',
  PARTIALLY_LABEL_GENERATED: 'Partially Label Generated',
  DRAFT: 'Draft',
};

const shipmentUploadType = {
  MANUAL: 'MANUAL',
  AUTOMATED: 'AUTOMATION',
  ADDRESS: 'ADDRESS',
};

const configurationIdMap = {
  DEFAULT_UNIT_OF_MEASUREMENT: 'default_unitofmeasurement',
  DEFAULT_CURRENCY: 'default_currency',
  DEFAULT_COUNTRY_MANUFACTURE: 'default_countryofmanufacture',
  DEFAULT_WEIGHT: 'default_weight',
  MOTHER_ACCOUNT_NUMBERS: 'mother_accountnumbers',
  BABY_ACCOUNT_NUMBERS: 'baby_accountnumbers',
  MOTHER_INCOTERM: 'mother_incoterm',
  DEFAULT_INCOTERM: 'default_incoterm',
  MOTHER_EXPORT_DECLARATION_DETAILS: 'mother_exportdeclarationdetails',
  OUTPUT_IMAGE_PROPERTIES: 'output_imageproperties',
  PRE_ALERT_REPORT: 'prealert_reportparams',
  PAPERLESS_TRADE: 'paperless-trade',
  DEFAULT_INVOICE_EXPORT: 'default_invoice_export',
  CUSTOMER_CREDENTIAL: 'customer_credential',
  LOOSE_BBX: 'loose_bbx',
  UNIITPRICE_DECIMAL: 'unitPriceDecimalPoints',
  LABEL_PRINT_CONFIGURATION: 'label_print_config',
  DEFAULT_SHIPMENT_CONTENT: 'default_shipment_content',
  BABY_DEFAULT_OPTIONS: 'baby_default_options',
  PICKUPS_DEFAULT_OPTIONS: 'pickup_default_settings',
  REPORT_CONFIG: 'report_configuration',
  PRODUCT_CODE_LIST: 'productcode_list',
  INDIVIDUAL_SHIP_ACCOUNT_NUMBERS: 'individualShip_accountnumbers',
  INDIVIDUAL_SHIPMENT_EXPORT_DECLARATION_DETAILS: 'individualShipment_exportdeclarationdetails',
};

const configurationIdMapForMother = {
  MOTHER_BABY_DEST_COUNTRY: 'mother_baby_destcountry_mapping',
  DEFAULT_INVOICE_EXPORT: 'default_invoice_export',
};

const configurationIdMapForEmailConfiguration = {
  PREALERT_EMAILS: 'prealert_emails',
  PREALERT_REPORTPARAMS: 'prealert_reportparams',
};

const configurationIdMapForTaxSetting = {
  IMPORTER_TAX_SETTING: 'importer_tax_setting',
  RECEIVER_TAX_SETTING: 'receiver_tax_setting',
  SHIPPER_TAX_SETTING: 'shipper_tax_setting',
};

const configurationIdMapForShipmentDetails = {
  BABY_ACCOUNT_NUMBERS: 'baby_accountnumbers',
  DEFAULT_UNIT_OF_MEASUREMENT: 'default_unitofmeasurement',
  DEFAULT_CURRENCY: 'default_currency',
  MOTHER_EXPORT_DECLARATION_DETAILS: 'mother_exportdeclarationdetails',
  DEFAULT_COUNTRY_OF_MANUFACTURE: 'default_countryofmanufacture',
  GLOBAL_SERVICE_CODES: 'global_servicecodes',
  MOTHER_INCOTERM: 'mother_incoterm',
  BABY_DEFAULT_OPTIONS: 'baby_default_options',
  DEFAULT_SHIPMENT_CONTENT: 'default_shipment_content',
};

const configurationIdMapForShipmentDetailsUpdate = {
  GLOBAL_SERVICE_CODES: 'global_servicecodes',
};

const motherShipperDeatilsconfiguration = {
  MOTHER_SHIPPER_DETAILS: 'mother_shipperdetails',
};

const configurationIdMapForShipmentDetailsUpdateEvent = {
  BABY_DEFAULT_OPTIONS: 'baby_default_options',
};

const configurationIdMapForLineItems = {
  DEFAULT_UNIT_OF_MEASUREMENT: 'default_unitofmeasurement',
  DEFAULT_CURRENCY: 'default_currency',
  MOTHER_EXPORT_DECLARATION_DETAILS: 'mother_exportdeclarationdetails',
  DEFAULT_COUNTRY_OF_MANUFACTURE: 'default_countryofmanufacture',
};

const allconfig = {
  DEFAULT_UNIT_OF_MEASUREMENT: 'default_unitofmeasurement',
  DEFAULT_CURRENCY: 'default_currency',
  DEFAULT_COUNTRY_MANUFACTURE: 'default_countryofmanufacture',
  DEFAULT_WEIGHT: 'default_weight',
  MOTHER_ACCOUNT_NUMBERS: 'mother_accountnumbers',
  BABY_ACCOUNT_NUMBERS: 'baby_accountnumbers',
  MOTHER_INCOTERM: 'mother_incoterm',
  DEFAULT_INCOTERM: 'default_incoterm',
  MOTHER_EXPORT_DECLARATION_DETAILS: 'mother_exportdeclarationdetails',
  OUTPUT_IMAGE_PROPERTIES: 'output_imageproperties',
  PRE_ALERT_REPORT: 'prealert_reportparams',
  PAPERLESS_TRADE: 'paperless-trade',
  DEFAULT_INVOICE_EXPORT: 'default_invoice_export',
  CUSTOMER_CREDENTIAL: 'customer_credential',
  LOOSE_BBX: 'loose_bbx',
  UNIITPRICE_DECIMAL: 'unitPriceDecimalPoints',
  LABEL_PRINT_CONFIGURATION: 'label_print_config',
  DEFAULT_SHIPMENT_CONTENT: 'default_shipment_content',
  BABY_DEFAULT_OPTIONS: 'baby_default_options',
  PICKUPS_DEFAULT_OPTIONS: 'pickup_default_settings',
  REPORT_CONFIG: 'report_configuration',
  DEFAULT_SHIPPER: 'default_shipper_address',
  ADDITIONAL_SERVICES: 'additional_services',
  PACKAGING_TYPES: 'packaging_types',
  SERVICE_AREA_CODES: 'servicearea_codes',
  GLOBAL_SERVICE_CODES: 'global_servicecodes',
  MOTHER_BABY_DEST_COUNTRY: 'mother_baby_destcountry_mapping',
  PREALERT_EMAILS: 'prealert_emails',
  MOTHER_SHIPPER_DETAILS: 'mother_shipperdetails',
  IMPORTER_TAX_SETTING: 'importer_tax_setting',
  RECEIVER_TAX_SETTING: 'receiver_tax_setting',
  SHIPPER_TAX_SETTING: 'shipper_tax_setting',
  PRE_ALERT_REPORTS: 'PRE_ALERT_REPORT',
  MANIFESTED_REPORT: 'MANIFESTED_REPORT',
  CLOSED_MOTHER_SHIPMENT: 'CLOSED_MOTHER_SHIPMENT',
  // CI_REPORTS: 'CI_REPORTS',
  SHIPPER_ADDRESS: 'SHIPPER_ADDRESS',
  RECEIVER_ADDRESS: 'RECEIVER_ADDRESS',
  // CUSTOMER_SHIPMENT_MAPPING: 'customer_mapping_specifications',
  // CUSTOMER_INVOICE_MAPPING: 'customer_invoice_specifications',
  SAVE_RECIEVER_ADDRESS: 'save_reciever_address',
  ADDITIONAL_CHARGES: 'additional_charges',
  AUTO_PRINT_LABEL: 'auto_print_labels',
  INDIVIDUAL_SHIP_ACCOUNT_NUMBERS: 'individualShip_accountnumbers',
  INDIVIDUAL_SHIPMENT_EXPORT_DECLARATION_DETAILS: 'individualShipment_exportdeclarationdetails',
  PRODUCT_CODE_LIST: 'productcode_list',
};

const validForShipmentLineItemsFormat = ['.txt', '.csv'];

const validForCIFormat = ['.pdf', '.png', '.jpeg', 'gif', 'tiff'];

const validAddressFormat = ['.csv'];

const TRACKING_BASE_URL = 'https://mydhl.express.dhl/au/en/tracking.html#';

const NOT_RESTRICTED_SPECIAL_PROVISION = 'HU5';

const configurationIdMapForProductName = {
  PRODUCT_CODE_LIST: 'productcode_list',
};

const configurationIdMapForProductCode = {
  BABY_ACCOUNT_NUMBERS: 'baby_accountnumbers',
  INDIVIDUAL_SHIP_ACCOUNT_NUMBERS: 'individualShip_accountnumbers',
};

export {
  shipmentStatusMap,
  configurationIdMap,
  configurationIdMapForEmailConfiguration,
  configurationIdMapForTaxSetting,
  configurationIdMapForShipmentDetails,
  configurationIdMapForLineItems,
  configurationIdMapForShipmentDetailsUpdate,
  shipmentUploadType,
  configurationIdMapForMother,
  validForShipmentLineItemsFormat,
  validForCIFormat,
  validAddressFormat,
  TRACKING_BASE_URL,
  configurationIdMapForShipmentDetailsUpdateEvent,
  motherShipperDeatilsconfiguration,
  allconfig,
  NOT_RESTRICTED_SPECIAL_PROVISION,
  configurationIdMapForProductName,
  configurationIdMapForProductCode,
};
